var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19.0475C16 20.5203 17.1939 21.7142 18.6667 21.7142H45.3333C46.8061 21.7142 48 20.5203 48 19.0475C48 17.5748 46.8061 16.3809 45.3333 16.3809H18.6667C17.1939 16.3809 16 17.5748 16 19.0475ZM29.899 29.1839C31.0974 27.9856 32.8948 27.9856 34.0931 29.1839L46.6755 41.7662C47.8738 42.9645 47.8738 44.762 46.6755 45.9603C46.0763 46.5595 45.4772 46.8591 44.5784 46.8591C43.6797 46.8591 43.0805 46.5595 42.4814 45.9603L31.9961 35.4751L21.5108 45.9603C20.3125 47.1587 18.515 47.1587 17.3167 45.9603C16.1184 44.762 16.1184 42.9645 17.3167 41.7662L29.899 29.1839Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollTop);
export default __webpack_public_path__ + "static/media/scroll-top.ab3910f24c26315886ce2411fbc47023.svg";
export { ForwardRef as ReactComponent };